import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueGtag from 'vue-gtag';

Vue.use(Vuetify);
Vue.use(VueGtag, {
  config: {
    id: "UA-15250648-33"
  }
});

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 850,
      sm: 960,
      md: 1280,
      lg: 1920
    },
    scrollBarWidth: 16
  },
  theme: {
    themes: {
      light: {
        primary: '#00535e',
        accent: '#f4f4f4'
      }
    }
  }
});
